/**
 * Created by Jason on 2017-3-6.
 */
import '../../assets/lib/boostrap/css/bootstrap.css'
import '../../assets/lib/fontawesome/css/font-awesome.min.css';
import '../../assets/css/main.less'
import '../topic/topic.less';

import '../../assets/lib/boostrap/js/bootstrap';
import main from '../../assets/js/main';
import util from '../../assets/js/util';
;

import fullLoading from  '../../assets/lib/full-loading/full-loading';
import '../../assets/lib/full-loading/full-loading.css';

import TopicDetail from '../../assets/js/topic-detail';
import '../../assets/css/topic-detail.css';

//翻页
import '../../assets/lib/paging/paging.css';
import Paging from '../../assets/lib/paging/paging';

//文件上传框
import '../../assets/lib/upload-box/index.css';
import  UploadBox from '../../assets/lib/upload-box';
{

    let topic = {

        init(userData, productName) {
            let _this = this;
            _this.userData = userData;
            _this.$sidebarMenu = $("#sidebar-menu");
            _this.companyId = util.getCompanyId();
            _this.productId = _this.$sidebarMenu.find('.check').data('type') - 0;
            _this.productId = _this.$sidebarMenu.find('.check').eq(0).data('type') - 0;
            _this.topicId = NaN;
            //任务列表
            _this.$topicList = $("#topic-list");
            _this.isCompanyRefresh = false;
            _this.isTopicListRefresh = false;
            //任务
            _this.$topicBox = $("#topic-box");
            _this.identityName = {
                'SERVICE_STAFF' : '服务人员',
                'REVIEW_STAFF': '复核人员'
            };
            _this.topicSearchWord = '';
            //上传文件初始化
            //初始化拖拽宽度
            _this.initDrag();
            //初始化类型
            _this.checkTopicType();
            //任务列表管理
            _this.createTopicList();
            _this.refreshTopicList();
            _this.checkTopicListEvent();
            //搜索任务
            _this.topicDetailObject = new TopicDetail(_this.$topicBox, userData, productName, userData.company.userType != 3);

        },
        /**
         * 拖拽宽度
         */
        initDrag() {
            let $topicListDrag = $("#topic-list-drag");
            let $topicListBox = $('#topic-list-box')
            let $dragBg = $("#drag-bg");
            let topicListWidth = localStorage.getItem('layout.topicListWidth') || $topicListBox.width();
            let topicListWidthRange = {
                min: 260,
                max: 460
            }
            let pageX = 0;
            //初始化宽度
            $topicListBox.css('width', topicListWidth);
            $topicListDrag.on('mousedown', (e) => {
                $dragBg.css('display', 'block');
                pageX = e.pageX;
                topicListWidth = topicListWidth - 0;
            });
            $dragBg.on('mouseup mousecancel', (e) => {
                $dragBg.css('display', 'none');
                topicListWidth = inRange(topicListWidthRange, topicListWidth + e.pageX - pageX);
                localStorage.setItem('layout.topicListWidth', topicListWidth);
            });
            $dragBg.on('mousemove', (e) => {

                let width = topicListWidth + e.pageX - pageX;

                $topicListBox.css('width', inRange(topicListWidthRange, width));
            });
            /**
             * 在范围之内
             * @param widthRange
             * @param width
             */
            function inRange (widthRange, width) {
                if (width < widthRange.min) {
                    return widthRange.min;
                }
                if (width > widthRange.max) {
                    return widthRange.max;
                }
                return width;
            }
        },
        /**
         * 选择任务类型
         */
        checkTopicType() {
            let _this = this;
            _this.$sidebarMenu.on("click", (e) => {
                let $t = $(e.target);
                let $closest = $t.closest('a');
                let productId = $closest.data('type') - 0;
                if (!$closest.length || !/topic\.html/.test($closest.attr('href')) || productId === _this.productId) {
                    return
                }

                //当前回复是否放弃
                _this.topicDetailObject.smallReply(() => {
                    _this.$sidebarMenu.find('.check').removeClass('check');
                    $closest.addClass('check');
                    //拉取数据
                    _this.productId = productId;
                    _this.initTopicList();
                })
            });
        },
        /**
         * 初始化渲染任务列表
         */
        initTopicList() {
            let _this = this;
            _this.TopicListPaging.init((result) => {
                if (result) {
                    _this.topicId = NaN;
                    _this.$topicBox.fadeOut(200);
                }
            });
        },
        /**
         * 创建任务列表分页
         */
        createTopicList() {
            let _this = this;
            _this.TopicListPaging = new Paging({
                el: _this.$topicList,
                getData: (page, size, setHTML, error, isRefresh) => {
                    $.get(SERVER + '/topic/topicList', {
                        "productId": _this.productId || 0,
                        "companyId": _this.companyId || 0,
                        "pageSize": size,
                        "pageNum": page
                    }, (json) => {
                        if (json.status == 0) {
                            _this.topicListData = json.data && json.data.content;
                            _this.renderTopicList(json.data, setHTML, isRefresh)
                        }
                    });
                },
                pageSize: 10
            })
        },
        /**
         * 渲染任务列表
         * @param list
         * @param setHTML
         * @param isRefresh
         */
        renderTopicList(list, setHTML, isRefresh) {
            let html = ``;
            let _this = this;
            let content = list.content;
            //遍历
            let hasCheck = false;
            content.forEach((topic) => {
                if (_this.topicId == topic.topicId) {
                    html += _this.renderTopicItem(topic, true);
                    hasCheck = true;
                } else {
                    html += _this.renderTopicItem(topic, false);
                }
            });
            if (isRefresh && !hasCheck) {
                html = (_this.$topicList.find('.check').eq(0).outerHTML || '') + html;
            }
            setHTML(html);
        },
        /**
         * 渲染单个任务
         * @param topic
         * @param isCheck
         * @returns {string}
         */
        renderTopicItem (topic, isCheck) {
            let html = '';
            if (isCheck) {
                html += `<li data-id="${topic.topicId}" class="check">`
            } else {
                html += `<li data-id="${topic.topicId}">`
            }
            html += `
                <strong>${topic.title}</strong>
                <em>${topic.contentShort}</em>
                <span><i class="fa fa-plus fa-fw"></i> 创建：<b>${topic.topicAddUserName}</b> ${util.getTimeStr(topic.addTime)}<br />`;
            if (topic.replyAddUserID) {
                html += `
                <i class="fa fa-comment fa-fw"></i> 回复：<b>${topic.replyAddUserName}</b> ${util.getTimeStr(topic.replyAddTime)}
                </span><div class="topic-type-icon"></div></li>
                `;
            }
            return html;
        },
        /**
         * 处理树形数据 公司->任务->任务详情
         * 适用：切换任务，搜索和过滤任务，切换公司，过滤搜索公司，切换任务类型
         * @param cb
         * 下面参数每个参数可选值 init, hide
         * @param topicList
         * @param topic
         */
        initTree(cb, topicList, topic) {
            let _this = this;
            _this.topicDetailObject.smallReply(() => {
                cb && cb();
                if (topicList === 'init') {
                    _this.TopicListPaging.init();
                    topic = 'hide';
                }
                if (topic === 'hide') {
                    _this.topicId = 0;
                    _this.$topicBox.hide();
                } else if(topic === 'init') {
                    //切换任务
                    _this.topicDetailObject.getTopic(_this.topicId, (result) => {
                        if (!result) {
                            _this.$topicBox.hide()
                        } else {
                            _this.$topicBox.fadeIn(200)
                        }

                    });
                }
            });
        },

        /**
         * 更换任务某个任务的数据
         * @param data
         */
        changeTopicItemData(data) {
            let _this = this;
            let topicId = data.topicId;
            let $li = _this.$topicList.find('[data-id="' + topicId + '"]');
            if (!$li.length) {
                return;
            }
            $li.find('strong').html(data.title);
            $li.find('em').html(data.contentShort);
            return $li;
        },


        /**
         * 刷新topic list事件
         */
        refreshTopicList() {
            let $refresh = $("#refresh-topic-list");
            let _this = this;
            $refresh.on('click', () => {
                //开始旋转
                _this.TopicListPaging.refresh((result)=> {
                    result && util.success('刷新成功')
                });
            });
        },
        /**
         * 任务点击事件
         */
        checkTopicListEvent() {
            let _this = this;
            _this.$topicList.on('click', function (e) {
                let $t = $(e.target);
                let $closest = $t.closest('li');
                if (!$closest.length) {
                    return;
                }
                let id = $closest.data('id');
                if (!id || id === _this.topicId) {
                    return;
                }
                //放弃回复判断
                _this.initTree(() => {
                    _this.$topicList.find('.check').removeClass('check')
                    $closest.addClass('check');
                    _this.topicId = id;
                }, null, _this.companyId ? 'init' : 'hide');
            });
        }
    }
    main.ready((userData, a, b, productName) => {
        topic.init(userData, productName)
    });
}



// WEBPACK FOOTER //
// ./src/pages/topic/topic.js